import * as React from "react"
import {Navigate} from "react-router-dom";
import {Box, Grid} from "@mui/material";
import {CardSeeker, ImageSeeker} from "@ui-seeker/core";

import {useUserApp} from "@hooks";
import StandaloneStyles from "Theme/GlobalStyles";
import LoginForm from "./Form";


export default function LoginPage() {
    const { isLogged } = useUserApp()

    if (isLogged)
        return <Navigate to="/" replace />

    return <>
        <StandaloneStyles />

        <CardSeeker title="SKU Mapper" sx={{ width: "70vw", height: "70vh" }} contentProps={{  sx: { height: 1 } }}>
            <Grid container sx={{ height: .9 }}>
                <Grid item xs={4} xl={3} sx={{ pl: 3 }}>
                    <LoginForm />
                </Grid>

                <Grid item xs={8} xl={9} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Box sx={{ width: 1 }}>
                        <ImageSeeker
                            src="/images/scrape_matcher_login.png"
                            containerProps={{ sx: { span: { display: 'flex !important', justifyContent: 'flex-end' } } }}
                            sx={{ width: .9, height: 'auto' }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </CardSeeker>
    </>
}